import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import styles from './Header.module.scss';
import logoUOL from '../../assets/images/logo-uol.svg';
import logosPainel from '../../assets/images/logos-painel.svg';
import ChargeModal from '../ChargeModal/ChargeModal';

declare global {
  interface Window { UOL: any; }
}

const Header: React.FC = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);

  useEffect(() => {
    const widgetScript = document.createElement('script');

    widgetScript.src = '//conteudo.jsuol.com.br/p/perfil/js/widgetNotify.v3.js';
    widgetScript.type = 'text/javascript';
    widgetScript.onload = () => new window.UOL.perfil.widgets.Notify({
      target: 'widgetNotify',
    });

    document.head.appendChild(widgetScript);
  });

  const showModal = () => {
    setModalIsVisible(true);
  };

  const hideModal = () => {
    setModalIsVisible(false);
  };

  return (
    <>
      {modalIsVisible ? <ChargeModal hide={hideModal} /> : null}

      <header className={styles.header}>
        <div className="container-fluid">
          <div className={styles.menuTop}>
            <div>
              <a className={styles.logoUOL} href="https://uol.com.br" target="_blank" rel="noopener noreferrer">
                <img src={logoUOL} width="75" alt="UOL" />
              </a>
            </div>
            <div className={styles.widgetNotifyContainer}>
              <div id="widgetNotify" className={styles.widgetNotify} />
            </div>
          </div>

          <div className={styles.menuBottom}>
            <Link className={styles.painelLogos} to="/">
              <img src={logosPainel} width="380" alt="UOL Meu Negócio e UOL Host" />
            </Link>

            <div className={styles.linksContainer}>
              <a className={styles.links} href="https://uolhost.uol.com.br/ajuda/" target="_blank" rel="noopener noreferrer">
                Perguntas frequentes
                <span className={`glyphicon glyphicon-share ${styles.shareIcon}`} aria-hidden="true" />
              </a>

              <button className={styles.links} type="button" onClick={showModal}>
                Cobrança
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
